<template>
  <span>
    <v-tooltip
      top
      close-delay="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          small
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-alert-circle-outline</v-icon>
        </v-btn>
      </template>
      <div style="width:250px">
        仅针对交易达成意向以及原则性条款并针对主要合作内容订立的合同，
        该合同中并不包含具体的交易细节（例如金额、数量等）；具体交易细节将通过后续子合同或订单等进行明确。
        若申请人无法判断，可于企业微信中咨询“獬豸”公号。
      </div>
    </v-tooltip>
  </span>
</template>
<script>
  export default {
    
  }
</script>
